export enum PageHeaderAlertTypes {
  TRIAL_EXPIRED = 'trial-expired',
  PAYMENT_PENDING = 'payment-pending',
  NONE = 'none',
}
